import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  } from 'src/app/util/constants';
import { ToastrService } from "ngx-toastr";
import {BASE_URL_CERT_GEN, BASE_URL_SCAB} from "../util/constants";

@Injectable()
export class CertificadoService {

  constructor(
    public http: HttpClient,
    private toast: ToastrService,
    private authService: AuthService,
  ) {
  }

  async validar(chave: string, token: string): Promise<any> {
    let usuarioLogado = await this.authService.getUsuarioLogado();
    console.log('usuarioLogado', usuarioLogado);
    let url = `${BASE_URL_SCAB}/api/sisab/valida-token-chave`;

    let cpf = usuarioLogado.cpf.trim().replace(/\D/gi, '');

    url += `?chave=${chave}&`;
    url += `cpf=${cpf}&`;
    url += `token=${token}`;

    return this.http.get(url).toPromise();
  }


  async download(subject: string, password: string): Promise<any> {
    let url = `${BASE_URL_CERT_GEN}/create`;

    return this.http.post(url, {
      "acSubject": "CN=AC-PORTAL-SERVICOS, O=DATASUS, C=BR",
      "format": "PKCS12",
      "password": password,
      "subject": subject,
      "type": "eCNPJ",
      "validityInDays": 365
    }).toPromise();
  }

  async revolke(SN: string): Promise<any> {
    let url = `${BASE_URL_CERT_GEN}/revoke/${SN}`;

    return this.http.delete(url).toPromise();
  }

  async listCert(identificador: string): Promise<any> {
    let usuarioLogado = await this.authService.getUsuarioLogado();
    console.log('usuarioLogado', usuarioLogado);
    let url = `${BASE_URL_CERT_GEN}/list?identificador=${identificador}&type=eCNPJ`;

    return this.http.get(url).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/certificado.service.ts